function decimal(value) {
  const num = Number(value);
  if (!num || num <= 0) return null;

  return num.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export default function formatAreaMinMax({ min, max }, areaUnit) {
  const minNumber = Number(min);
  const maxNumber = Number(max);

  if (!minNumber && !maxNumber) return null;

  const minFormatted = decimal(minNumber);
  const maxFormatted = decimal(maxNumber);

  let result = "";

  if (minNumber > 0 && maxNumber > 0) {
    result = `${minFormatted}-${maxFormatted}`;
  } else if (minNumber > 0) {
    result = `≥ ${minFormatted}`;
  } else {
    result = `≤ ${maxFormatted}`;
  }

  const units = {
    alqueire: "alq",
    hectare: "ha",
    metros: "m²",
  };

  const unit = units[areaUnit] || "";

  return unit ? `${result} ${unit}` : result;
}
